import React from 'react';
import { CollapsibleDetailsSection } from '../../components';
import { TERMINAL_CONNECTIVITY_DETAILS } from '@shared/data/mockTerminalsPanels';

interface ConnectivitySectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  isDetailView?: boolean;
  className?: string;
}

export const ConnectivitySection = React.memo<ConnectivitySectionProps>(({ isExpanded, onToggle, isDetailView = false, className }) => {
  const handleTestConnection = () => {
    console.log('Test connection clicked');
    // Add your test connection logic here
  };

  const actions = [
    {
      label: 'Test Connection',
      onClick: handleTestConnection
    }
  ];

  return (
    <CollapsibleDetailsSection
      title="Connectivity"
      details={TERMINAL_CONNECTIVITY_DETAILS}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isDetailView={isDetailView}
      emptyMessage="No connectivity details available"
      actions={actions}
      className={className}
    />
  );
});

ConnectivitySection.displayName = 'ConnectivitySection';